<template>
  <b-button v-if="visible" size="sm" variant="primary" :to="{ name: routeName }" aria-label="Group Message">
    <i class="fa fa-bullhorn"></i>
  </b-button>
</template>

<script>
import { mapState } from 'vuex'
import { hasGroupMessageAccess, groupMessageRouteName } from '../utils/alerts_access'

function isMobileDevice() {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent)
}

export default {
  name: 'VsmGroupMessageLinkButton',
  computed: {
    ...mapState({ user: state => state.profile.user }),
    visible() { return hasGroupMessageAccess(this.user) && !isMobileDevice() },
    routeName() { return groupMessageRouteName(this.user) },
  },
}
</script>
